import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { SchoolWidget } from '@/widgets/school-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.searchByName': z.string().optional(),
  'filter.names': z.array(z.string()).optional(),
  'filter.active': z.boolean().optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/administration/reference-books/schools')({
  staticData: {
    meta: {
      title: 'Школы',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: SchoolsLayout,
})

function SchoolsLayout() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.SCHOOLS}>
      <PageWrapper title={t('Справочники: Школы')}>
        <SchoolWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
